import { ApiService } from '../../../services/apiService'
import { i18n } from '@/lang';
import { StoreHelper } from 'Helpers/storeHelper'
import { HtmlWebClientException } from 'GlobalErrors/HtmlWebClientException';
import { compare } from 'fast-json-patch'

const initialState = () => {
  return {
    businessDetails: StoreHelper.state(null),
    googleSelectedLocation: null,
    websiteUrl: null,
    creativeLoader: null,
    signUpDetails: null,
    defaultEstimation: StoreHelper.state(null),
    isInAppCampaign: false,
    facebookPageDetail: null,
    businessLogo: null,
    currentBusinessLogo: null,
    customUploadedLogoImages: [],
    customUploadedLeadImages: [],
    isCustomUploadedBusinessLogo: false,
    googlePlaceDetails: null,
    signUpRequest: null,
    signUpSteps: null,
    subsequentSteps: null,
    currentSection: null,
    currentRoute: null,
    isRegionChangePromptTriggered: false,
    isBusinessLogoModalEnabled: false,
    isAutoGeneratedFlow: false
  }
}

const {
  extractBusinessDetails,
  updateAggregatedData,
  setOfferDetails,
  getAggregatedbusinessDetails,
  generateEstimation
} = new ApiService();
export const state = initialState();

export const getters = {
  businessDetails: state => state.businessDetails.data,
  googleSelectedLocation: state => state.googleSelectedLocation,
  websiteUrl: (state, rootGetters) => {
    if(rootGetters.roimaticConfiguration){
      return rootGetters.roimaticConfiguration.localBusinessConfiguration.websiteUrl;
    }
    else{
      return state.websiteUrl;
    }
  },
  selectedFacebookPageId: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.facebookPageId,
  suggestedCategories: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.suggestedCategories,
  category: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.category,
  services: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.services,
  suggestedServices: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.suggestedServices,
  gender: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.gender,
  businessName: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.name,
  businessLocation: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.location,
  objective: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.creativeDetail && state.businessDetails.data.creativeDetail.objective,
  offerDetail: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.offerDetail,
  promoteServices: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.creativeDetail && state.businessDetails.data.creativeDetail.promoteServices,
  selectedTemplateId: state => state.businessDetails && state.businessDetails.data && state.businessDetails.data.creativeDetail && state.businessDetails.data.creativeDetail.selectedTemplateId,
  isError: state => state.businessDetails && state.businessDetails.status && state.businessDetails.status.fail,
  creativeLoader: state => state.creativeLoader,
  signUpDetails: state => state.signUpDetails,
  defaultEstimation: state => state.defaultEstimation.data,
  businessLogo: state => state.businessLogo,
  currentBusinessLogo: state => state.currentBusinessLogo,
  isInAppCampaign: (state) => {
    return state.isInAppCampaign;
  },
  facebookPageDetail: (state, rootGetters) => {
    if(rootGetters.roimaticConfiguration){
      return rootGetters.roimaticConfiguration.localBusinessConfiguration.facebookPageDetail;
    }
    else{
      return state.facebookPageDetail;
    }
  },
  customUploadedLogoImages: state => state.customUploadedLogoImages,
  customUploadedLeadImages: state => state.customUploadedLeadImages,
  isCustomUploadedBusinessLogo: state => state.isCustomUploadedBusinessLogo,
  googlePlaceDetails: (state, rootGetters) => {
    if (state.googlePlaceDetails){
      return state.googlePlaceDetails;
    } else if(rootGetters.roimaticConfiguration) {
      return rootGetters.roimaticConfiguration.localBusinessConfiguration.googlePlaceDetail;
    } else {
      return null;
    }
  },
  signUpRequest: state => state.signUpRequest,
  signUpSteps: state => state.signUpSteps,
  subsequentSteps: state => state.subsequentSteps,
  currentSection: state => state.currentSection,
  currentRoute: state => state.currentRoute,
  currentStep: (state, rootGetters) => {
    if(rootGetters.isInAppCampaign){
      if(rootGetters.currentRoute && rootGetters.currentSection && state.subsequentSteps){
        var subsequentFlowStep = state.subsequentSteps.find(s => s.section === rootGetters.currentSection);
        var stepNumber = subsequentFlowStep.steps.findIndex(s => s.route.includes(rootGetters.currentRoute)) + 1;
        return stepNumber;
      }
    }
    else{
      if(rootGetters.currentRoute && rootGetters.currentSection  && state.signUpSteps){
        var signUpFlowStep = state.signUpSteps.find(s => s.section === rootGetters.currentSection);
        var stepNumber = signUpFlowStep.steps.findIndex(s => s.route.includes(rootGetters.currentRoute)) + 1;
        return stepNumber;
      }
    }
  },
  totalStepCount: (state, rootGetters) => {
    if(rootGetters.isInAppCampaign){
      if(rootGetters.currentRoute && rootGetters.currentSection  && state.subsequentSteps){
        var subsequentFlowStep = state.subsequentSteps.find(s => s.section === rootGetters.currentSection);
        return subsequentFlowStep.steps.length;
      }
    }
    else{
      if(rootGetters.currentRoute && rootGetters.currentSection  && state.signUpSteps){
        var signUpFlowStep = state.signUpSteps.find(s => s.section === rootGetters.currentSection);
        return signUpFlowStep.steps.length;
      }
    }
  },
  isRegionChangePromptTriggered: state => state.isRegionChangePromptTriggered,
  isBusinessLogoModalEnabled: (state) => state.isBusinessLogoModalEnabled,
  isAutoGeneratedFlow: state => state.isAutoGeneratedFlow
};

export const mutations = {
  setDefaultEstimation(state, defaultEstimation) {
    state.defaultEstimation = StoreHelper.updateState(state.defaultEstimation, defaultEstimation);
  },
  resetPersistedState: (state) => {
    Object.assign(state, initialState());
  },
  setBusinessDetails(state, businessDetails) {
    state.businessDetails = StoreHelper.updateState(state.businessDetails, businessDetails);
  },
  setWebsiteUrl(state, websiteUrl) {
    state.websiteUrl = websiteUrl;
  },
  setGoogleSelectedLocation(state, googleSelectedLocation) {
    state.googleSelectedLocation = googleSelectedLocation;
  },
  updateCreativeLoader(state, payload) {
    state.creativeLoader = payload;
  },
  setSignUpDetails(state, payload) {
    state.signUpDetails = payload
  },
  setIsInAppCampaign(state, payload) {
    state.isInAppCampaign = payload
  },
  setFacebookPageDetail(state, payload) {
    state.facebookPageDetail = payload;
  },
  setBusinessLogo(state, payload){
    state.businessLogo = payload;
  },
  setCurrentBusinessLogo(state, payload){
    state.currentBusinessLogo = payload
  },
  setCustomUploadedLogoImages(state, payload){
    state.customUploadedLogoImages = payload;
  },
  addCustomUploadedLogoImages(state, payload){
    state.customUploadedLogoImages.push(payload);
  },
  setCustomUploadedLeadImages(state, payload){
    state.customUploadedLeadImages = payload;
  },
  addCustomUploadedLeadImages(state, payload){
    state.customUploadedLeadImages.push(payload);
  },
  setIsCustomUploadedBusinessLogo(state, payload) {
    state.isCustomUploadedBusinessLogo = payload;
  },
  setGooglePlaceDetails(state, payload) {
    state.googlePlaceDetails = payload;
  },
  setSignUpRequest(state, payload) {
    state.signUpRequest = payload
  },
  resetSignUpRequest(state) {
    state.signUpRequest = StoreHelper.state(null)
  },
  setSignUpSteps(state, payload) {
    state.signUpSteps = payload;
  },
  setSubsequentSteps(state, payload) {
    state.subsequentSteps = payload;
  },
  setCurrentStep(state, payload) {
    state.currentStep = payload;
  },
  setTotalStepCount(state, payload) {
    state.totalStepCount = payload;
  },
  setCurrentSection(state, payload) {
    state.currentSection = payload;
  },
  setCurrentRoute(state, payload) {
    state.currentRoute = payload;
  },
  setIsBusinessLogoModalEnabled(state, payload){
    state.isBusinessLogoModalEnabled = payload;
  },
  setRegionChangePromptTriggered(state, payload) {
    state.isRegionChangePromptTriggered = payload;
  },
  setIsAutoGeneratedFlow(state, payload) {
    state.isAutoGeneratedFlow = payload;
  }
};

export const actions = {
  setIsInAppCampaign: (context, payload) => {
    context.commit('setIsInAppCampaign', payload);
  },
  resetPersistedState: (context) => {
    context.commit('resetPersistedState');
  },
  setFacebookPageDetail: (context, payload) => {
    context.commit('setFacebookPageDetail', payload);
  },
  setBusinessLogo: (context, payload) => {
    context.commit('setBusinessLogo', payload);
  },
  setCurrentBusinessLogo: (context, payload) => {
    context.commit('setCurrentBusinessLogo', payload);
  },
  setCustomUploadedLogoImages: (context, payload) => {
    context.commit('setCustomUploadedLogoImages', payload);
  },
  addCustomUploadedLogoImages: (context, payload) => {
    context.commit('addCustomUploadedLogoImages', payload);
  },
  setCustomUploadedLeadImages: (context, payload) => {
    context.commit('setCustomUploadedLeadImages', payload);
  },
  addCustomUploadedLeadImages: (context, payload) => {
    context.commit('addCustomUploadedLeadImages', payload);
  },
  setIsCustomUploadedBusinessLogo(context, payload) {
    context.commit('setIsCustomUploadedBusinessLogo', payload);
  },
  setIsBusinessLogoModalEnabled(context, payload){
    context.commit('setIsBusinessLogoModalEnabled', payload);
  },
  async getDefaultEstimation(context, payload) {
    try {
      context.commit('clearMessages');
      context.commit('setDefaultEstimation');
      let defaultEstimation = await generateEstimation(payload.businessProfileId, payload.campaignId);
      if (defaultEstimation) {
        context.commit('setDefaultEstimation', defaultEstimation);
      }
    } catch (error) {
      context.commit('setDefaultEstimation', error);
      context.commit('updateMessage', { type: 'error', text: i18n.tc('message.bizgainOnboarding.failedToFetchBudget') });
    }
  },
  async getBusinessDetails(context, payload) {
    try {
      if (payload && payload.sessionId) {
        context.commit('clearMessages');
        context.commit('setBusinessDetails');
        let businessDetail = await getAggregatedbusinessDetails(payload.sessionId);
        if (businessDetail) {
          context.commit('setBusinessDetails', businessDetail);
        }
      }
    } catch (error) {
      context.commit('setBusinessDetails', error);
    }
  },
  async setBusinessDetails(context, payload) {
    try {
      if (payload) {
        context.commit('clearMessages');
        context.commit('setBusinessDetails');
        let businessDetails = await extractBusinessDetails(payload.websiteUrl, payload.facebookPageDetails, payload.googlePlaceDetails, payload.name, payload.category, payload.region, payload.shortenFlow, payload.queryParameters);
        if (businessDetails) {
          context.commit('setBusinessDetails', businessDetails);
        }
      }
    } catch (error) {
      context.commit('setBusinessDetails', error);
      if (error instanceof HtmlWebClientException) {
        context.commit('updateMessage', {
          type: 'error',
          text: i18n.tc('message.bizgainOnboarding.invalidWebsiteUrl')
        });
      }
    }
  },
  async patchBusinessDetails(context, payload) {
    try {
      if (payload && payload.oldBusinessDetails && payload.newBusinessDetails && payload.sessionId) {
        // Update freshchat identifiers in business details for initial flow
        if ((localStorage.getItem('freshChatRestoreId') && localStorage.getItem('freshChatExternalId'))) {
          payload.newBusinessDetails.freshChatRestoreId = localStorage.getItem('freshChatRestoreId');
          payload.newBusinessDetails.freshChatExternalId = localStorage.getItem('freshChatExternalId');
          localStorage.removeItem('freshChatRestoreId');
          localStorage.removeItem('freshChatExternalId');
        }

        let jsonPatch = compare(payload.oldBusinessDetails, payload.newBusinessDetails);
        if (Array.isArray(jsonPatch) && jsonPatch.length > 0) {
          context.commit('clearMessages');
          context.commit('setBusinessDetails');
          let patchRequest = {
            sessionId: payload.sessionId,
            businessDetail: jsonPatch
          }
          await updateAggregatedData(patchRequest);
          context.commit('setBusinessDetails', payload.newBusinessDetails);
        }
      }
    } catch (error) {
      context.commit('setBusinessDetails', error);
    }
  },
  setWebsiteUrl(context, payload) {
    context.commit('setWebsiteUrl', payload);
  },
  setGoogleSelectedLocation(context, payload) {
    context.commit('setGoogleSelectedLocation', payload);
  },
  updateCreativeLoader(context, payload) {
    context.commit('updateCreativeLoader', payload);
  },
  updateBusinessDetails(context, payload) {
    context.commit('setBusinessDetails', payload);
  },
  setSignUpDetails(context, payload) {
    context.commit('setSignUpDetails', payload);
  },
  setGooglePlaceDetails(context, payload){
    context.commit('setGooglePlaceDetails', payload)
  },
  async updateOfferDetails(context, payload) {
    try {
      if (payload && payload.businessDetails && payload.offerDetail) {
        context.commit('clearMessages');
        context.commit('setBusinessDetails');
        let requestBody = {
          sessionId: payload.businessDetails.sessionId,
          offerDetail: payload.offerDetail
        }
        let adDetails = await setOfferDetails(requestBody);
        if (adDetails) {
          payload.businessDetails.offerDetail = payload.offerDetail;
          if (payload.businessDetails.creativeDetail && payload.businessDetails.creativeDetail.adDetail) {
            payload.businessDetails.creativeDetail.adDetail = adDetails;
          }
          context.commit('setBusinessDetails', payload.businessDetails);
        }
      }
    } catch (error) {
      context.commit('setBusinessDetails', error);
    }
  },
  setSignUpRequest(context, payload) {
    context.commit('setSignUpRequest', payload);
  },
  resetSignUpRequest(context) {
    context.commit('resetSignUpRequest');
  },
  setSignUpSteps(context, payload){
    context.commit('setSignUpSteps', payload);
  },
  setSubsequentSteps(context, payload){
    context.commit('setSubsequentSteps', payload);
  },
  setCurrentStep(context, payload) {
    context.commit('setCurrentStep', payload);
  },
  setTotalStepCount(context, payload) {
    context.commit('setTotalStepCount', payload);
  },
  setCurrentSection(context, payload) {
    context.commit('setCurrentSection', payload);
  },
  setCurrentRoute(context, payload) {
    context.commit('setCurrentRoute', payload);
  },
  setRegionChangePromptTriggered(context, payload) {
    context.commit('setRegionChangePromptTriggered', payload)
  },
  setIsAutoGeneratedFlow(context, payload) {
    context.commit('setIsAutoGeneratedFlow', payload);
  }
};

